import {
  call, put, all, select,
} from 'redux-saga/effects';
import { apiAuthPartner, updateUser } from 'services/api/auth';
import api from 'services/api';
import { Creators as AuthCreators, getTriiderUser } from '../ducks/auth';
import { Creators as ServiceCreators } from '../ducks/services';
import { Creators as CategoriesCreators } from '../ducks/categories';
import { Creators as CompanyCreators } from '../ducks/company';
import { Creators as TaskCreators } from '../ducks/task';
import { Creators as UserAreaCreators } from '../ducks/userArea';
import { Creators as UiCreators, growlTypes } from '../ducks/ui';
import { getErrorMessage } from '../../utils/filters';

export function* getUser({ payload }) {
  try {
    let data;
    yield put(UiCreators.showLoader('GETUSER'));
    if (payload.companyName) {
      data = yield call(apiAuthPartner, payload.companyName, payload.token);
    } else {
      // senão passar empresa recebe triider
      data = yield call(apiAuthPartner, 'triider', payload.token);
    }
    if (data.user) {
      data.user.token = data.token;
      yield localStorage.setItem('token', JSON.stringify(data.token));
      const {
        token, user, role, address,
      } = data;
      yield localStorage.setItem(
        'triiderUser',
        JSON.stringify({
          token,
          user,
          role,
          address,
          isPartner: true,
          company_info: data.company_info,
          source: payload.companyName,
        }),
      );

      yield put(
        UserAreaCreators.fetchTriiderUser({
          token,
          user,
          role,
          address,
          isPartner: true,
          company_info: data.company_info,
          source: payload.companyName,
        }),
      );
      yield put(
        AuthCreators.getUserByHashSuccess({
          token,
          user,
          role,
          address,
        }),
      );

      api.defaults.headers.common['api-token'] = token;
      api.defaults.headers.common.source = 'partners';
    } else {
      yield localStorage.removeItem('token');
      yield localStorage.removeItem('triiderUser');
      yield put(UserAreaCreators.fetchTriiderUser({}));
      yield put(AuthCreators.getUserByHashSuccess({}));
    }
    if (data.services) {
      yield put(ServiceCreators.getServicesSuccess(data.services));
    } else {
      // Caso ocorrer erro envia empresa triider 1 e
      // cidade padrão Porto Alegre para buscar os serviços
      yield put(ServiceCreators.getServicesByCityRequest({ id: 1 }));
    }

    if (data.categories) {
      yield put(CategoriesCreators.getCategoriesSuccess(data.categories));
    } else {
      // Caso ocorrer erro envia empresa triider 1 e
      // cidade padrão Porto Alegre para buscar os serviços
      yield put(CategoriesCreators.getCategoriesByCityRequest({ id: 1 }));
    }

    if (data.company_info) {
      yield put(CompanyCreators.getCompanySuccess(data.company_info));
    } else {
      yield put(CompanyCreators.getCompanySuccess({}));
    }

    if (data.company_info && data.user) {
      yield put(TaskCreators.getTaskRequest(data.user));
    }
    if (
      data.user
      && data.user.email
      && !data.user.partners_email_validated
      && (data.user.cpf || data.user.cnpj)
    ) {
      yield put(AuthCreators.setModalEmail(true));
    } else {
      yield put(AuthCreators.setModalEmail(false));
    }
    yield put(UiCreators.hideLoader('GETUSER'));
  } catch (error) {
    const message = getErrorMessage(error);
    yield localStorage.removeItem('token');
    yield localStorage.removeItem('triiderUser');
    yield put(UserAreaCreators.fetchTriiderUser({}));
    yield put(AuthCreators.getUserByHashSuccess({}));
    yield put(
      UiCreators.growl(message, growlTypes.GROWL_ERROR, {
        error,
      }),
    );
    yield put(UiCreators.hideLoader('GETUSER'));
    // Caso ocorrer erro envia empresa triider 1 e
    // cidade padrão Porto Alegre para buscar os serviços
    yield put(ServiceCreators.getServicesByCityRequest({ id: 1 }));
  }
}

export function* updateTriiderUser({ payload: { fields } }) {
  const triiderUser = yield select(getTriiderUser);
  const { user } = triiderUser;

  try {
    yield put(UiCreators.showLoader('UPDATE_USER'));

    const data = yield call(updateUser, fields, user.id);
    if (data.success) {
      Object.assign(user, fields);

      const newUser = {
        ...triiderUser,
        user,
      };

      yield put(AuthCreators.fetchTriiderUser(newUser));
      yield put(UserAreaCreators.fetchTriiderUser(newUser));
      yield put(AuthCreators.setHaveAccount(false));
      yield put(UiCreators.hideLoader('UPDATE_USER'));
      yield put(UiCreators.growl('Email atualizado com sucesso!', growlTypes.GROWL_SUCCESS));
      yield localStorage.setItem('triiderUser', JSON.stringify(newUser));
    }
  } catch (error) {
    yield put(UiCreators.hideLoader('UPDATE_USER'));
    yield put(AuthCreators.setHaveAccount(true));
    // yield put(UiCreators.growl('Realize o seu login', growlTypes.GROWL_SUCCESS));
    console.error(error);
  }
}

export function* updateUserLogin({ payload }) {
  const triiderUser = yield select(getTriiderUser);
  try {
    yield put(UiCreators.showLoader('LOGIN'));

    const { user, token } = payload;
    const newUser = {
      ...triiderUser,
      user,
      token,
    };
    yield put(AuthCreators.fetchTriiderUser(newUser));
    yield put(UserAreaCreators.fetchTriiderUser(newUser));
    yield put(AuthCreators.setHaveAccount(false));
    yield put(TaskCreators.getTaskRequest(user));
    yield put(UiCreators.hideLoader('LOGIN'));
    yield put(UiCreators.growl('Login realizado com sucesso!', growlTypes.GROWL_SUCCESS));
    yield localStorage.setItem('triiderUser', JSON.stringify(newUser));
  } catch (error) {
    yield put(UiCreators.hideLoader('LOGIN'));
    yield put(UiCreators.growl(`Erro:${getErrorMessage(error)}`, growlTypes.GROWL_ERROR));
    console.error(error);
  }
}
